module.exports = __webpack_public_path__ + "img/wenz.470a3dbb.jpg";